export default "/images/vendor/flag-icons/flags/1x1/vu.svg?6d23e1e3760f25096417bc6005d9bf86";